import { AlertTriangle } from "lucide-react";
import { useEffect } from "react";

import { useAppSelector } from "../../../app/store";
import { formatDateWithOrdinal } from "../../../lib/utils";
import { getPlannedMaintenanceDates } from "../../configs/logic/Slice";

const BANNER_HEIGHT = 64;

const PlannedMaintenanceBanner = () => {
  const maintenanceDates = useAppSelector(getPlannedMaintenanceDates);

  const startDate = maintenanceDates ? new Date(maintenanceDates.startDate) : null;
  const endDate = maintenanceDates ? new Date(maintenanceDates.endDate) : null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const isMaintenanceActive = (() => {
    if (!startDate || !endDate) return false;
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);
    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0);
    
    return today >= start && today <= end;
  })();

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--maintenance-banner-height",
      isMaintenanceActive ? `${BANNER_HEIGHT}px` : "0px"
    );
    return () => {
      document.documentElement.style.setProperty(
        "--maintenance-banner-height",
        "0px"
      );
    };
  }, [isMaintenanceActive]);

  if (!isMaintenanceActive || !startDate || !endDate) return null;

  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  return (
    <div className="flex w-full items-center bg-[#334155] px-4 py-3 gap-4" style={{ height: BANNER_HEIGHT }}>
      <AlertTriangle className="h-6 w-6 shrink-0 text-[#FFFFFF] mr-2" />

      <div className="flex flex-1 flex-col">
        <span className="font-sans text-sm font-semibold leading-5 text-[#FFFFFF]">
          Platform Upgrades in Progress
        </span>
        <span className="font-sans text-xs font-normal leading-4 text-[#FFFFFF]">
          We're rolling out major functionality releases, platform upgrades, and data migrations starting{" "}
          <span className="font-semibold">{formatDateWithOrdinal(startDate)}</span> until{" "}
          <span className="font-semibold">{formatDateWithOrdinal(endDate)}</span>. There is no planned downtime,
          but we recommend limiting platform usage during this period to allow the data migrations and upgrades to
          complete smoothly.
        </span>
      </div>
    </div>
  );
};

export default PlannedMaintenanceBanner;